var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoccss(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.75 13.75H21.25C20.9848 13.75 20.7304 13.6446 20.5429 13.4571C20.3554 13.2696 20.25 13.0152 20.25 12.75V8.25M25.75 13.75V26.75C25.75 27.0152 25.6446 27.2696 25.4571 27.4571C25.2696 27.6446 25.0152 27.75 24.75 27.75H11.25C10.9848 27.75 10.7304 27.6446 10.5429 27.4571C10.3554 27.2696 10.25 27.0152 10.25 26.75V9.25C10.25 8.98478 10.3554 8.73043 10.5429 8.54289C10.7304 8.35536 10.9848 8.25 11.25 8.25H20.25M25.75 13.75L20.25 8.25",
    stroke: "currentColor",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.75 13.75H21.25C20.9848 13.75 20.7304 13.6446 20.5429 13.4571C20.3554 13.2696 20.25 13.0152 20.25 12.75V8.25M25.75 13.75V26.75C25.75 27.0152 25.6446 27.2696 25.4571 27.4571C25.2696 27.6446 25.0152 27.75 24.75 27.75H11.25C10.9848 27.75 10.7304 27.6446 10.5429 27.4571C10.3554 27.2696 10.25 27.0152 10.25 26.75V9.25C10.25 8.98478 10.3554 8.73043 10.5429 8.54289C10.7304 8.35536 10.9848 8.25 11.25 8.25H20.25M25.75 13.75L20.25 8.25M13.5 17H22.5M13.5 19.75H22.5M13.5 22.5H19",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoccss);
export default __webpack_public_path__ + "static/media/doccss.5755d2712264c65b0d6f9d2392e0c53c.svg";
export { ForwardRef as ReactComponent };